<template>
     <v-select
             ref="inputRef"
             :id=id
             v-model=selected
             :multiple=multiple
             :options = options
             @search = onSearch
             @input="()=> $emit('input', selected)"
             :label = label
             :getOptionLabel=getOptionLabel
             :reduce="(option) => reduceKey ? option[reduceKey] : option "
             :placeholder="placeholder"
             :debounce="500"
             :loading="loading"
             :preload="preload"
             :filterable="filterable"
             :searchable="searchable"
             :closeOnSelect="!multiple"
     >
          <template #no-options>
               Нет данных, попробуйте другое условие поиска
          </template>

         <template #list-footer >
             <li class="w-100 p-1 text-center" v-show="currentPage + 1 <= Math.ceil(totalElements/perPage)">
                 <b-link variant="primary" @click="currentPage += 1">Загрузить еще</b-link>
             </li>
         </template>
     </v-select>
</template>
<script>

    import { ref, onMounted, watch } from '@vue/composition-api'
    import vSelect from 'vue-select'
    import { BLink } from 'bootstrap-vue'
    import debounce from 'lodash.debounce'
    import uniqBy from 'lodash.uniqby'
    import get from 'lodash.get'


    export default {

        components: {
            vSelect,
            BLink
        },

        props: {

            id: {
                type: String,
                required: false,
            },
            placeholder: {
                type: String,
                default: "Поиск ...",
                required: false,
            },
            label: {
                type: String,
                required: false,
            },

            fetchOptions: {
                type: Function,
                required: true,
            },
            fetchOptionsExtraConfig: {
                type: Object,
                default: ()=>{
                    return {}
                },
                required: false,
            },

            initialValue: {
                type: Array,
                default: () => {
                    return []
                },
                required: false,
            },
            multiple: {
                type: Boolean,
                default: false,
                required: false,
            },
            reduceKey: {
                type: String,
                default: null,
                required: false,
            },
            getOptionLabel: {
                type: Function,
                required: false,
            },
            preload: {
                type: Boolean,
                default: true,
                required: false,
            },
            filterable: {
                type: Boolean,
                default: false,
                required: false,
            },
            searchable: {
                type: Boolean,
                default: true,
                required: false,
            },

            responseDataPath: {
                type: String,
                default: "['results']",
                required: false,
            },

            perPagePath: {
                type: String,
                default: null,
                required: false,
            },

            totalElementsPath: {
                type: String,
                default: "['count']",
                required: false,
            },
        },

        setup(props, {emit}) {

            const inputRef = ref()
            const search = ref('')
            const options = ref([...props.initialValue]);
            const selected = ref();

            onMounted( () => {
                  if (props.initialValue.length > 0) {
                       selected.value = [...props.initialValue].map(el => props.reduceKey ? el[props.reduceKey] : el)
                       selected.value = props.multiple ? selected.value : selected.value[0]
                       emit('input', selected.value)
                  }

                if (props.preload) refetchData()

            })
            const currentPage = ref(1)
            const perPage = ref(20)
            const totalElements = ref(0)

            const loading = ref(false)

            const refetchData = () => {
                loading.value = true
                const { url, id, params } = props.fetchOptionsExtraConfig
                props.fetchOptions(
                    {url: url, id: id , params: { search: search.value, size: perPage.value, page: currentPage.value, ...params}},
                    (data) => {
                        options.value = uniqBy([
                            ...get(data, props.responseDataPath, []),
                            ...options.value
                        ], props.reduceKey);
                        perPage.value = get(data, props.perPagePath, perPage.value);
                        totalElements.value = get(data, props.totalElementsPath, totalElements.value);
                        loading.value = false
                    },
                    () => loading.value = false
                )
            }

            const onSearch = debounce((input) => search.value = input, 900)

            watch(currentPage, () => {
                refetchData()
            }, { deep: true } )

            watch(search, () => {
                options.value = [...inputRef.value.selectedValue]
                currentPage.value = 1
                refetchData()
            }, { deep: true } )


            return {
                inputRef,
                options,
                selected,
                onSearch,

                loading,

                currentPage,
                perPage,
                totalElements,

            }

  }
}
</script>
<style lang="scss" scoped>
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
